import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import './OpsReqStepper.scss';

export type NewReqStep = 'brief' | 'turns';

interface OpsReqStepperProps {
  step: NewReqStep;
  briefDone?: boolean;
  onChange?: (step: NewReqStep) => void;
}

function OpsReqStepper({
  step,
  briefDone = false,
  onChange,
}: OpsReqStepperProps) {
  const { t } = useTranslation();
  const i18nBase =
    'scenes.requirements_operation.components.new_operation_request.stepper';

  const steps: {
    key: NewReqStep;
    letter: string;
    label: string;
    sub: string;
  }[] = [
    {
      key: 'brief',
      letter: 'A',
      label: t(`${i18nBase}.steps.brief.label`),
      sub: t(`${i18nBase}.steps.brief.sub`),
    },
    {
      key: 'turns',
      letter: 'B',
      label: t(`${i18nBase}.steps.turns.label`),
      sub: t(`${i18nBase}.steps.turns.sub`),
    },
  ];

  return (
    <div className="ops-req-stepper">
      {steps.map((s) => {
        const active = step === s.key;
        const done = s.key === 'brief' && briefDone && step === 'turns';
        const clickable = !!onChange && (s.key === 'brief' || briefDone);

        return (
          <button
            key={s.key}
            type="button"
            disabled={!clickable}
            className={`ops-req-stepper__item${
              active ? ' ops-req-stepper__item--active' : ''
            }${done ? ' ops-req-stepper__item--done' : ''}`}
            onClick={() => clickable && onChange?.(s.key)}
          >
            <span
              className={`ops-req-stepper__num${
                done ? ' ops-req-stepper__num--check' : ''
              }`}
            >
              {done ? <CheckOutlined /> : s.letter}
            </span>
            <div className="ops-req-stepper__text">
              <div className="ops-req-stepper__label">{s.label}</div>
              <div className="ops-req-stepper__sub">{s.sub}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default OpsReqStepper;
